export const COMPANY_ROLES = {
  INCUMBENT_COMPANY: "INCUMBENT_COMPANY",
  SUBCONTRACTOR: "SUBCONTRACTOR",
  COCONTRACTOR: "COCONTRACTOR",
};
